import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { FancyDropdown } from 'apps/builder/components/settings/modal'
import Select from 'react-select'
import { selectStyles } from 'apps/builder/components/shared'
import {
  sheetsSelector,
  entriesSelector,
  paymentFieldDataToIncludeSelector,
  paymentFieldScreenSelector,
  paymentFieldDataToIncludeTableSelector,
  activeFieldInTableSelector,
} from 'apps/builder/store/selectors'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { updateEntry } from 'apps/builder/store/actions/entries'
import {
  checkNumberStyleForPaymentTotalField,
  whiteListedTypesForPaymentField,
} from 'apps/builder/lib/utils'

export const PaymentField = ({
  guid,
  label,
  type,
  keyField,
  style,
  dependent_entry,
  summary_entry,
}) => {
  const dispatch = useDispatch()
  const allEntries = useSelector(entriesSelector)
  const isFieldInATable = useSelector(activeFieldInTableSelector)
  const sheets = useSelector(sheetsSelector)
  const dataToInclude = isFieldInATable
    ? useSelector(paymentFieldDataToIncludeTableSelector)
    : useSelector(paymentFieldDataToIncludeSelector)
  const validSheets = useSelector(paymentFieldScreenSelector)

  const [paymentScreen, setPaymentScreen] = useState('')
  const [validEntries, setValidEntries] = useState([])

  const screenOptions = validSheets.map(sheet => {
    return {
      value: sheet.id,
      label: sheet.description || sheet.placeholder || `Type screen name`,
    }
  })

  const dataToIncludeOptions = dataToInclude.map(option => {
    return { value: option.guid, label: option.label || `New ${option.type}` }
  })

  useEffect(() => {
    if (dependent_entry && dependent_entry.guid) {
      const e = allEntries.find(entry => entry.guid == dependent_entry.guid)
      const { sheet_id } = e || {}
      const foundSheet = sheets.find(s => s.id == sheet_id)
      setPaymentScreen({
        label:
          foundSheet.description ||
          foundSheet.placeholder ||
          `Type screen name`,
        value: foundSheet.id,
      })
    }

    if (!dependent_entry && summary_entry) {
      dispatch(
        updateEntry({
          guid: guid,
          summary_entry: null,
        })
      )
    }
  }, [])

  useEffect(() => {
    const filteredEntries = allEntries
      .filter(e => {
        if (
          whiteListedTypesForPaymentField.includes(e.type) &&
          checkNumberStyleForPaymentTotalField(e) &&
          e.sheet_id == paymentScreen.value
        ) {
          return e
        }
      })
      .map(e => {
        return { label: e.label, value: e.guid }
      })

    setValidEntries(filteredEntries)
  }, [paymentScreen])

  const sharedProps = {
    styles: selectStyles,
    classNamePrefix: 'react-select',
  }
  const paymentScreenProps = {
    ...sharedProps,
    options: screenOptions,
    value: paymentScreen,
    className: `${!screenOptions.length && 'react-select__invalid invalid'}`,
    onChange: value => {
      setPaymentScreen(value)
      dispatch(
        updateEntry({
          guid: guid,
          dependent_entry: null,
        })
      )
    },
    isDisabled: !screenOptions.length,
    placeholder: !screenOptions.length ? 'Payment Total Screen' : '',
  }

  const getPaymentFieldValue = () => {
    if (dependent_entry) {
      const e = allEntries.find(entry => entry.guid == dependent_entry.guid)
      return { value: e.guid, label: e.label }
    } else {
      return null
    }
  }

  const paymentFieldProps = {
    ...sharedProps,
    options: validEntries,
    value: getPaymentFieldValue(),
    className: `${!validEntries.length && 'react-select__invalid invalid'}`,
    onChange: ({ value }) => {
      dispatch(
        updateEntry({
          guid: guid,
          dependent_entry: value ? { guid: value } : null,
        })
      )
    },
    isDisabled: !validEntries.length,
    placeholder: !validEntries.length ? 'Payment Total Field' : '',
  }

  const dataPaymentProps = {
    ...sharedProps,
    options: dataToIncludeOptions,
    value: summary_entry
      ? dataToIncludeOptions.filter(
          option => option.value == summary_entry.guid
        )
      : '',
    onChange: ({ value }) => {
      dispatch(
        updateEntry({
          guid: guid,
          summary_entry: value ? { guid: value } : null,
        })
      )
    },
    isDisabled: !dataToIncludeOptions.length || !dependent_entry,
    placeholder:
      !dataToIncludeOptions.length || !dependent_entry
        ? 'Data to include with Payment'
        : '',
  }
  return (
    <div className="settings--field">
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
          style={style}
        />
      </div>
      <div className="settings--row no-border">
        <div className="settings--payment">
          <FancyDropdown
            label={screenOptions.length > 0 && 'Payment Total Screen'}
          >
            <Select {...paymentScreenProps} />
          </FancyDropdown>

          <FancyDropdown
            label={validEntries.length > 0 && 'Payment Total Field'}
            error={!validEntries.length}
            errorText={
              'To use a Payment field, you must first add a Number (with decimal or currency style) or Calculation field to your app.'
            }
          >
            <Select {...paymentFieldProps} />
          </FancyDropdown>
          <FancyDropdown
            label={
              dataToIncludeOptions.length && dependent_entry
                ? 'Data to include with Payment'
                : ''
            }
          >
            <Select {...dataPaymentProps} />
          </FancyDropdown>
        </div>
        <div className="info--block--container">
          <div className="foundry--surface surface--info info--block">
            <p>
              GoCanvas allows you to integrate with Square, which means you can
              immediately and easily collect payment using your App and Square's
              supported devices.
            </p>
            <a
              className="info--block--link"
              href="https://help.gocanvas.com/hc/en-us/articles/115006629607"
              target="blank"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
